module.exports = __webpack_public_path__ + "static/media/engine-icon-error.3ebeff7d.png";